import React, {Component} from "react";
import {connect} from "react-redux";
import {RocketTwoTone} from '@ant-design/icons';
import {Layout} from "antd";
import dayjs from 'dayjs';
import AppActions from "bukku/redux/App/actions";
import TopbarUser from "./topbarUser";
import TopbarQuickAdd from "./TopbarQuickAdd";
import TopbarWrapper from "./topbar.style";
import StartDrawer from 'bukku/components/Drawer/Start';
import TopbarNotification from "../../components/Notifications";
import {getOpenKeys} from "../../helpers/urlSync";
// import TopbarSearch from "./topbarSearch";
import GlobalSearch from "bukku/components/GlobalSearch";
import BukkuTooltip from "../../components/Tooltip";

const { Header } = Layout;
const {
    toggleCollapsed,
    startDrawerSet,
    changeOpenKeys,
} = AppActions;

class Topbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // startDrawerVisible: false,
        };
    }

    /**
   * Drawer functions
   **/
    // Start drawer
    showStartDrawer = () => {
        const {
            startDrawerSet,
        } = this.props;

        startDrawerSet(true);
    };

    onStartDrawerClose = () => {
        const {
            startDrawerSet,
        } = this.props;

        startDrawerSet(false);
    };

    isNewAccount = () => {
        const {
            company,
        } = this.props;

        if (!company)
            return false;

        const startDate = dayjs(company.created_at);
        const todayDate = dayjs();
        const dayDiff = todayDate.diff(startDate, 'day');
        if (dayDiff > 30)
            return false;
        return true;
    };

    renderMenuList = () => {
        const {
            user,
        } = this.props;
        const items = [];
        const locale = 'en';

        // Nothing
        if (!user)
            return items;

        if (this.isNewAccount()) {
            items.push(
                <li key="start">
                    <BukkuTooltip
                        arrowPointAtCenter
                        title="Get started with Bukku. This button will disappear after the first 30 days."
                        popupContainerId="isomorphicTopbar"
                    >
                        <RocketTwoTone onClick={this.showStartDrawer} />
                    </BukkuTooltip>
                </li>,
            );
        }

        // Add new
        items.push(
            <li key="add" className="isoAdd">
                <TopbarQuickAdd locale={locale} />
            </li>,
        );

        // Search
        // items.push(
        //     <li key="search" className="isoSearch">
        //       <TopbarSearch locale={locale} />
        //     </li>
        // );

        // Search
        items.push(
            <li key="search" className="isoSearch">
                {/* <TopbarSearch locale={locale} /> */}
                <GlobalSearch />
            </li>,
        );

        items.push(
            <li key="notification" className="isoNotification">
                <TopbarNotification />
            </li>,
        );

        // User
        items.push(
            <li key="user" className="isoUser">
                <TopbarUser locale={locale} />
            </li>,
        );

        return items;
    };

    getCollapsed = () => {
        const { drawerCollapsedMode, drawerOpen } = this.props;
        return drawerCollapsedMode && !drawerOpen;
    };

    getClassName = () => {
        const collapsed = this.getCollapsed();

        let className = "isomorphicTopbar";
        if (collapsed)
            className += " collapsed";

        return className;
    };

    onCollapseChange = () => {
        const { toggleCollapsed, changeOpenKeys } = this.props;
        toggleCollapsed();

        const collapsed = this.getCollapsed();
        if (collapsed)
            changeOpenKeys(getOpenKeys());
    };

    render() {
        const {
            customizedTheme,
            startDrawer: startDrawerVisible,
        } = this.props;

        const collapsed = this.getCollapsed();

        const styling = {
            background: customizedTheme.backgroundColor,
            position: "fixed",
            width: "100%",
            height: 70,
        };

        return (
            <TopbarWrapper>
                <StartDrawer
                    open={startDrawerVisible}
                    onClose={this.onStartDrawerClose}
                />
                <Header
                    style={styling}
                    className={this.getClassName()}
                >
                    <div className="isoLeft">
                        <button
                            className={
                                collapsed ? "triggerBtn menuCollapsed" : "triggerBtn menuOpen"
                            }
                            style={{ color: customizedTheme.textColor }}
                            onClick={this.onCollapseChange}
                            type="button"
                        />
                    </div>
                    <ul className="isoRight">
                        { this.renderMenuList() }
                    </ul>
                </Header>
            </TopbarWrapper>
        );
    }
}

export default connect(state => ({
    company: state.Auth.company,
    user: state.Auth.user,
    ...state.App,
    drawerCollapsedMode: state.App.drawerCollapsedMode,
    drawerOpen: state.App.drawerOpen,
    customizedTheme: state.ThemeSwitcher.topbarTheme,
}), {
    toggleCollapsed,
    changeOpenKeys,
    startDrawerSet,
})(Topbar);
